import useSWR from 'swr'
import ServiceAPI from '~services/services'

export const useFetchPopup = () => {
    const { data, mutate, error } = useSWR([`/popup`], () => ServiceAPI.getPopup());

    return {
        data,
        isLoading: !error && !data,
        isError: error,

        mutate,
    }
}

export default useFetchPopup
